const mutations = {
    add(state, object) {
        state.items.push(object);
    },
    setList(state, list) {
        state.items = list;
    },
    setObject(state, object) {
        state.item = object;
    },
    delObject(state, object) {
        state.items.splice(state.items.indexOf(object), 1);
    }
};

export default mutations;